import { makeResetStyles, mergeClasses } from '@fluentui/react-components';
import { tokens } from '@fluentui-copilot/tokens';
import type { GroundingCommandBarSlots, GroundingCommandBarState } from './GroundingCommandBar.types';
import type { SlotClassNames } from '@fluentui/react-components';
import { GROUNDING_MENU_GRID_AREAS } from '../GroundingMenu/useGroundingMenuStyles.styles';

export const groundingCommandBarClassNames: SlotClassNames<GroundingCommandBarSlots> = {
  root: 'fai-GroundingCommandBar',
};

const useRootBaseClassName = makeResetStyles({
  gridArea: GROUNDING_MENU_GRID_AREAS.commandBar,
  width: '100%',
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '[tabs-start] 1fr [tabs-end actions-start] auto [actions-end]',
  padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
  boxSizing: 'border-box',
  borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
});

/**
 * Apply styling to the GroundingCommandBar slots based on the state
 */
export const useGroundingCommandBarStyles_unstable = (state: GroundingCommandBarState): GroundingCommandBarState => {
  'use no memo';

  const rootBaseClassName = useRootBaseClassName();

  state.root.className = mergeClasses(groundingCommandBarClassNames.root, rootBaseClassName, state.root.className);

  return state;
};
